import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../../api';
import api from '../../../../api/endpoints';

function* sendSendbirdBatchMessage({ payload: { values, multipart, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.sendbird.multi_message.send, data: values, multipart: !!multipart });

    onSuccess && onSuccess(data.result);
    yield put(actions.sendSendbirdBatchMessageDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.sendSendbirdBatchMessageFailed,
      handledErrors,
      endpoint: api.sendbird.multi_message.send.url
    });
  }
}

export const sendSendbirdBatchMessageSaga = takeEvery(types.SEND_SENDBIRD_BATCH_MESSAGE_REQUEST, sendSendbirdBatchMessage);